import React, { useState } from "react";
import { Plus } from "lucide-react";
import StudentPickerModal from "./StudentPickerModal";
import StudentListModal from "./StudentListModal";

export default function StudentSearchSection({ values, isViewMode, onToggleSendToAll, onAddStudent, onUpdateStudents }) {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [isListOpen, setIsListOpen] = useState(false);
  const courseId = values.courseId || null;
  const count = values.studentIds.length;

  return (
    <>
      <label className="teacher-mocks-manager-checkbox">
        <input
          type="checkbox"
          checked={values.sendToAll}
          onChange={onToggleSendToAll}
          disabled={isViewMode}
        />
        <span>
          <strong>Enviar para todos os alunos do curso</strong>
          <small>
            {values.sendToAll
              ? "O simulado será criado para todos os alunos com matrícula ativa no curso."
              : "Selecione os alunos que receberão este simulado."}
          </small>
        </span>
      </label>

      {!values.sendToAll && (
        <div className="teacher-mocks-student-picker">
          {count > 0 && (
            <div className="teacher-mocks-student-summary">
              <span className="teacher-mocks-student-count">
                Lista de Alunos ({count})
              </span>
              <button
                type="button"
                className="teacher-mocks-view-list-btn"
                onClick={() => setIsListOpen(true)}
              >
                Ver lista
              </button>
            </div>
          )}

          {!isViewMode && (
            !courseId
              ? <p className="teacher-mocks-student-hint">Selecione um curso para adicionar alunos.</p>
              : (
                <button
                  type="button"
                  className="teacher-mocks-add-student-btn"
                  onClick={() => setIsPickerOpen(true)}
                >
                  <Plus size={13} aria-hidden="true" />
                  Adicionar Aluno
                </button>
              )
          )}
        </div>
      )}

      {isPickerOpen && (
        <StudentPickerModal
          courseId={courseId}
          selectedIds={values.studentIds}
          onConfirm={(students) => students.forEach(onAddStudent)}
          onClose={() => setIsPickerOpen(false)}
        />
      )}

      {isListOpen && (
        <StudentListModal
          studentIds={values.studentIds}
          studentNames={values.studentNames}
          onConfirm={onUpdateStudents}
          onClose={() => setIsListOpen(false)}
        />
      )}
    </>
  );
}
